// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.radio-group-phone[data-v-dbf10ed0] .el-radio{\n  display: block;\n  line-height: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
